module.exports = __webpack_public_path__ + "static/media/2.51f6c363.jpg";